import React from "react";
import { useLocation } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import "./OrderSuccessPage.css"; // Reuse the same CSS file for a consistent look

const OrderSuccessPage = () => {
  const location = useLocation();
  const { order } = location.state || {}; // Safely get the order data

  if (!order) {
    return (
      <div className="order-success-page">
        <h1>Order Not Found</h1>
        <p>There was an issue retrieving your order details.</p>
      </div>
    );
  }

  return (
    <div className="order-success-page">
      <div className="success-icon">
        <FaCheckCircle />
      </div>
      <h1>Order Placed Successfully!</h1>
      <p>Thank you for your purchase, {order.customerName}.</p>
      <div className="order-summary">
        <h2>Order Summary</h2>
        <p>
          <strong>Order Date:</strong>{" "}
          {new Date(order.orderDate).toLocaleDateString()}
        </p>
        <h3>Products Ordered:</h3>
        <ul>
          {Object.values(order.products).map((item, index) => (
            <li key={index}>
              {item.length} | {item.weight} | {item.deliveryOption}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default OrderSuccessPage;
